import React from 'react'
import Image from 'next/image'
import Slogan from '../slogan.component'
import { imageLoaderForStaticImages } from '../../context/utils'
import { useAppContext } from '../../context/siteMapContext'

interface IContactProps {
  slogan: string
  phone: string
  mailTo: string
  addressTitle: string
  address: string
}

const Contact: React.FC<IContactProps> = ({
  slogan,
  phone,
  mailTo,
  address,
  addressTitle,
}) => {
  const { highContrastOn } = useAppContext();

  return (
    <>
      <Slogan slogan={slogan} />
      <div className='h-[3px] w-auto relative my-8 pr-8 2xl:my-[30px] 2xl:pr-[30px] bg-white'>
        {!highContrastOn && <Image
          loader={imageLoaderForStaticImages}
          alt=''
          src={'/common/gradient_line.svg'}
          layout='fill'
          objectFit='cover'
        />}
      </div>
      <div className='w-3/4 font-montserrat font-medium text-footer-text-2xl'>
        <p>{addressTitle}</p>
        <p>{address}</p>
        <p>
          Telefon:
          <span>
            <a href={`tel:${phone}`}> {phone}</a>
          </span>
        </p>
        <p>
          E-mail:
          <span>
            <a href={`mailto:${mailTo}`}> {mailTo}</a>
          </span>
        </p>
      </div>
    </>
  )
}

export default Contact
